/**
 * Parse le formulaire "Petit Déjeuner" copié depuis Google Sheet.
 * Port fidèle de lib/breakfastParser.ts du RG original.
 *
 * Format attendu (TAB-séparé) :
 *   timestamp \t nom \t date \t [vide] \t heure \t V1.protein \t V1.boisson \t V2.protein \t V2.boisson \t beurre \t confitures
 * Fallback : split sur 2+ espaces si pas de TAB.
 */

const EMPTY = { ok: false, raw: "", voyageurs: [], confitures: [] };

export function parseBreakfastForm(note) {
  if (!note || typeof note !== "string") return EMPTY;
  const text = note.trim();
  if (!text) return EMPTY;

  const lines = text.split(/\r?\n+/).map((l) => l.trim()).filter(Boolean);
  if (lines.length === 0) return EMPTY;

  for (let i = lines.length - 1; i >= 0; i--) {
    const line = lines[i];
    let cols = line.includes("\t") ? line.split("\t") : line.split(/\s{2,}/);
    cols = cols.map((c) => c.trim());
    if (cols.length < 5) continue;

    const [ts, nom, date, _empty, heure, ...rest] = cols;
    const voyageurs = [];
    let beurre;
    let confituresRaw = "";

    if (rest.length >= 6) {
      voyageurs.push({ protein: rest[0] || undefined, boisson: rest[1] || undefined });
      voyageurs.push({ protein: rest[2] || undefined, boisson: rest[3] || undefined });
      beurre = rest[4] || undefined;
      confituresRaw = rest[5] || "";
    } else if (rest.length >= 4) {
      voyageurs.push({ protein: rest[0] || undefined, boisson: rest[1] || undefined });
      beurre = rest[2] || undefined;
      confituresRaw = rest[3] || "";
    } else if (rest.length >= 2) {
      voyageurs.push({ protein: rest[0] || undefined, boisson: rest[1] || undefined });
    }

    const confitures = confituresRaw
      ? confituresRaw.split(/[,;]/).map((s) => s.trim()).filter(Boolean)
      : [];

    return {
      ok: true,
      raw: line,
      timestamp: ts || undefined,
      nom: nom || undefined,
      date: date || undefined,
      heure: heure || undefined,
      voyageurs: voyageurs.length > 0 ? voyageurs : [{}],
      beurre,
      confitures,
    };
  }
  return EMPTY;
}

export function proteinIcon(p) {
  if (!p) return "";
  const v = p.toLowerCase();
  if (v.includes("bacon")) return "🥓";
  if (v.includes("fromage")) return "🧀";
  if (v.includes("œuf") || v.includes("oeuf")) return "🥚";
  return "🍽️";
}
export function boissonIcon(b) {
  if (!b) return "";
  const v = b.toLowerCase();
  if (v.includes("café") || v.includes("cafe")) return "☕";
  if (v.includes("thé") || v.includes("the")) return "🍵";
  if (v.includes("chocolat")) return "🍫";
  return "🥤";
}
